import { Popconfirm } from 'antd';
import { BiEdit } from 'react-icons/bi';
import { TbTrash } from 'react-icons/tb';

export const columns = ({ t, setSelectedItem, modal, deleteData, setModal }) => [
    {
        title: "",
        key: "empty",
        width: 50,
        render: (a) => {
            return (
                <div className='h40px w40px round border d-flex justify-content-center align-items-center'>
                    {
                        <span className='color4'>{a?.firstName[0].toUpperCase()}.{a?.lastName[0].toUpperCase()}</span>
                    }
                </div>
            )
        }
    },
    {
        title: t('name'),
        key: t('name'),
        sorter: (a, b) => a?.firstName.localeCompare(b.firstName),
        render: (a) => {
            return a?.firstName + " " + a?.lastName.toUpperCase()
        }
    },
    {
        title: t('phone'),
        key: t('phone'),
        render: (a) => {
            return a?.phoneNumber
        }
    },
    {
        title: t('mail'),
        key: t('mail'),
        render: (a) => {
            return a?.email
        }
    },
    {
        title: t('process'),
        render: (a) => {
            return (
                <div className='d-flex justify-content-start'>
                    <div
                        onClick={() => { setSelectedItem(a?.userId); setModal(!modal) }}
                        className='text-warning border border-warning rounded p-2 cp'
                    >
                        <BiEdit size={22} />
                    </div>
                    <div className='text-danger border ml-2 border-danger rounded p-2 cp'>
                        <Popconfirm
                            title={t("content_delete_desc")}
                            onConfirm={() => deleteData(a?.userId)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <TbTrash size={22} />
                        </Popconfirm>
                    </div>
                </div >
            )
        }
    }
];